import { render, staticRenderFns } from "./InvoicesView.vue?vue&type=template&id=bb97c7b0&"
import script from "./InvoicesView.vue?vue&type=script&lang=js&"
export * from "./InvoicesView.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesView.vue?vue&type=style&index=0&id=bb97c7b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports